var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { OverlayTrigger } from "react-bootstrap";
import id from "@irati/utils/id";
import { Overlay as DefaultOverlay } from "./";
import { OverlayPlacement } from "./Overlay";
var Tooltip = function (_a) {
    var children = _a.children, _b = _a.placement, placement = _b === void 0 ? OverlayPlacement.Right : _b, tooltipChildren = _a.tooltipChildren, _c = _a.OverlayComponent, OverlayComponent = _c === void 0 ? DefaultOverlay : _c, props = __rest(_a, ["children", "placement", "tooltipChildren", "OverlayComponent"]);
    var idNamespace = id("Tooltip", props);
    return (React.createElement(OverlayTrigger, { id: id("trigger", idNamespace), placement: placement, overlay: React.createElement(OverlayComponent, { id: idNamespace }, tooltipChildren) }, children));
};
export default Tooltip;
